import request from '@/utils/request'

export function getPriceCodeListApi(query) {
  return request({
    url: '/config-service/v1/hotel/price-code',
    method: 'get',
    params: query
  })
}
export function getPaymentSubTransactionApi() {
  return request({
    url: '/config-service/v1/hotel/price-code/sub-transaction',
    method: 'get'
  })
}

export function getPackageListApi(query) {
  return request({
    url: '/config-service/v1/hotel/price-code/package',
    method: 'get',
    params: query
  })
}

export function getPackageSelectedListApi(query) {
  return request({
    url: '/config-service/v1/hotel/price-code/package-selected',
    method: 'get',
    params: query
  })
}

export function addPriceCodeApi(data) {
  return request({
    url: '/config-service/v1/hotel/price-code',
    method: 'post',
    data: data
  })
}

export function getPriceCodeDetailApi(query) {
  return request({
    url: '/config-service/v1/hotel/price-code/detail',
    method: 'get',
    params: query
  })
}

export function editPriceCodeApi(data) {
  return request({
    url: '/config-service/v1/hotel/price-code',
    method: 'put',
    data: data
  })
}

export function getPriceByLevelList(query) {
  return request({
    url: '/config-service/v1/hotel/price-code/price-by-level/',
    method: 'get',
    params: query
  })
}

export function getPriceByLevelDetail(query) {
  return request({
    url: '/config-service/v1/hotel/price-code/price-by-level/detail',
    method: 'get',
    params: query
  })
}

export function getRoomPriceByLevelApi(query) {
  return request({
    url: '/config-service/v1/hotel/price-code/price-room-level',
    method: 'get',
    params: query
  })
}

export function addPricePyLevelApi(data) {
  return request({
    url: '/config-service/v1/hotel/price-code/price-by-level',
    method: 'post',
    data: data
  })
}

export function editPriceByLevelApi(data) {
  return request({
    url: '/config-service/v1/hotel/price-code/price-by-level',
    method: 'put',
    data: data
  })
}

export function editPricePerRoomApi(data) {
  return request({
    url: '/config-service/v1/hotel/price-code/price-per-room',
    method: 'put',
    data: data
  })
}

export function deletePriceCodeApi(query) {
  return request({
    url: '/config-service/v1/hotel/price-code',
    method: 'delete',
    params: query
  })
}

export function editPriceRoomLevelApi(data) {
  return request({
    url: '/config-service/v1/hotel/price-code/price-room-level',
    method: 'put',
    data: data
  })
}
